import { useTranslation } from 'react-i18next'
import { Language } from './types'
import { availableLanguages } from './index'

export function useAppTranslation(namespace?: "common" | "navbar" | "vmm" | "trade" | "competition" | "margin" | "notifications" | "pagination" | "profile" | "refer" | "support" | "joiRide" | "portfolio" | "leaderboard" | readonly ("common" | "navbar" | "vmm" | "trade" | "competition" | "margin" | "notifications" | "pagination" | "profile" | "refer" | "support" | "joiRide" | "portfolio" | "leaderboard")[]) {
    return useTranslation(namespace)
}

export function useLanguageSwitcher() {
    const { i18n } = useTranslation()

    const switchLanguage = (language: Language) => {
        i18n.changeLanguage(language)
    }

    const getCurrentLanguage = (): Language => {
        return i18n.language as Language
    }

    const getLanguageDisplayName = (language: Language): string => {
        const displayNames: Record<Language, string> = {
            en: 'English',
            tr: 'Türkçe',
            ru: 'Русский',
        }
        return displayNames[language] || language
    }

    return {
        currentLanguage: getCurrentLanguage(),
        availableLanguages,
        switchLanguage,
        getLanguageDisplayName,
        isReady: i18n.isInitialized
    }
}